import React from "react";
import { Star } from "lucide-react";
import { testimonials, company } from "../mock";

const Testimonials = () => {
  return (
    <section id="recensioni" className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="font-display text-[#0f2846] text-3xl md:text-4xl font-bold">Cosa dicono i nostri clienti</h2>
          <div className="w-24 h-1 bg-[#e8464a] mx-auto mt-4 rounded-full" />
          <p className="text-slate-500 mt-5">Migliaia di clienti soddisfatti in tutta Italia. Ecco alcune delle loro recensioni.</p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-[#f4f6f9] rounded-2xl p-7 border border-slate-100 flex flex-col hover:shadow-md transition-all">
              <div className="flex gap-0.5 text-[#f5b301]">
                {[...Array(5)].map((_, j) => <Star key={j} size={17} fill="currentColor" />)}
              </div>
              <p className="text-slate-600 text-sm mt-4 leading-relaxed flex-1">"{t.text}"</p>
              <div className="flex items-center gap-3 mt-5 pt-5 border-t border-slate-200">
                <div className="w-10 h-10 rounded-full bg-[#0f2846] text-white flex items-center justify-center font-display font-bold">{t.name[0]}</div>
                <div>
                  <div className="font-semibold text-[#0f2846] text-sm">{t.name}</div>
                  <div className="text-slate-400 text-xs">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <p className="text-center text-slate-400 text-xs italic mt-8">
          Recensioni rappresentative dei clienti {company.name}. Sostituiremo con recensioni verificate da Google quando disponibili.
        </p>
      </div>
    </section>
  );
};

export default Testimonials;
